import * as React from 'react';
import {SyntheticEvent, useRef} from 'react';
import {Autocomplete, AutocompleteChangeReason, FormControl, TextField} from "@mui/material";
import Typography from "@mui/material/Typography";
import {Hobbies} from "../GiftFormValues";

const hobbiesOptions = Object.entries(Hobbies).map(([key, value]) => value);

const HobbiesForm: React.FC<{ updateValue: (value: string[]) => void, hobbies: string[] }> = (props) => {
    // Ref für das Inputfeld
    const inputRef = useRef<HTMLInputElement>(null);

    // Handler für onBlur
    const handleBlur = () => {
        const inputValue = inputRef.current?.value?.trim();
        if (inputValue && !props.hobbies.includes(inputValue)) {
            props.updateValue([...props.hobbies, inputValue]);
            if (inputRef.current) inputRef.current.value = '';
        }
    };

    return (
        <>
            <Typography variant="h6" gutterBottom={true}>
                Was macht der/die Beschenkte gerne? (Eigene Eingaben möglich)
            </Typography>
            <FormControl fullWidth>
                <Autocomplete
                    multiple
                    freeSolo
                    filterSelectedOptions
                    id="hobbies"
                    value={props.hobbies}
                    onChange={(
                        event: SyntheticEvent,
                        value: string[],
                        reason: AutocompleteChangeReason
                    ) => {
                        props.updateValue(value);
                    }}
                    options={hobbiesOptions}
                    getOptionLabel={(option) => option}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            inputRef={inputRef}
                            onBlur={handleBlur}
                            variant="standard"
                            label="Hobbies"
                            placeholder="Hobbies"
                            helperText="Du kannst auch eigene Eingaben machen."
                        />
                    )}
                />
            </FormControl>
        </>
    );
};

export default HobbiesForm;
